import { render, staticRenderFns } from "./BusinessObjEnts.vue?vue&type=template&id=fc21bd06&scoped=true&"
import script from "./BusinessObjEnts.vue?vue&type=script&lang=js&"
export * from "./BusinessObjEnts.vue?vue&type=script&lang=js&"
import style0 from "./BusinessObjEnts.vue?vue&type=style&index=0&id=fc21bd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc21bd06",
  null
  
)

export default component.exports